import { ApiResponse, Service } from '@roc/feature-app-core';

const url = {
  ALL_INSPECTIONS: '/api/v1/inspection/inspections',
  GET_INSPECTION_DETAILS: '/api/v1/inspection/getInspectionDetails',
  GET_INSPECTION_DETAILS_BY_EXTERNAL_IDS: '/api/v1/inspection/getInspectionDetailsByExternalIds',
  SUBMIT_INSPECTION_FOR_REVIEW: '/api/v1/inspection/submitInspectionForReview',
  // Same endpoint @roc/feature-general-tasks already calls; duplicated here (instead of importing
  // that lib) so feature-inspections doesn't pick up a new cross-feature dependency just to
  // resolve the active RealVal photo source for the Inspections Dashboard.
  GET_REALVAL_PHOTO_SOURCE: '/api/v1/taskV2/realValPhotoSource',
};

export interface PhotoSourceInfo {
  photoSource: string;
  photoSourceOther?: string;
  photosTakenDate: string;
}

export class InspectionService extends Service {
  public getAllInspections(
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    filters: string,
    dropdownFilters: string
  ): Promise<ApiResponse> {
    const params = {
      page,
      pageSize,
      sortBy,
      sortDir,
      filters,
      dropdownFilters,
    };

    return this.get(url.ALL_INSPECTIONS, params, {
      disableGlobalLoading: true,
    });
  }

  getInspectionDetails(inspectionId: number) {
    return this.get(url.GET_INSPECTION_DETAILS, { inspectionId });
  }

  getInspectionDetailsByExternalIds(externalId1: number, externalId2: number) {
    return this.get(url.GET_INSPECTION_DETAILS_BY_EXTERNAL_IDS, { externalId1, externalId2 });
  }

  submitInspectionForReview(inspectionId: number, photoSourceInfo?: PhotoSourceInfo) {
    return this.post(url.SUBMIT_INSPECTION_FOR_REVIEW, { inspectionId, ...photoSourceInfo });
  }

  getRealValPhotoSource(loanId: number, propertyId: number) {
    return this.get(url.GET_REALVAL_PHOTO_SOURCE, { loanId, propertyId });
  }
}
